
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolavasainnovacab() {



    const cardData =
    {
        keyword: 'Pune to Lavasa Innova Crysta Cab Booking',
        heading: 'Meghana Cab : Pune to Lavasa Innova Crysta Cab Booking',
        headingDescription: 'Meghana Cab offers Pune to Lavasa Innova Crysta Cab Booking, perfect for travelers seeking a comfortable, scenic, and luxurious getaway to the picturesque hill town of Lavasa. Our Innova Crysta vehicles are equipped with plush leather interiors, spacious seating, and ample luggage space—ideal for couples, families, and groups on a relaxed day trip or an extended stay. Journey through lush greenery and winding roads in style, with experienced chauffeurs who know the route and scenic spots along the way. Enjoy transparent fixed fares (one-way, round-trip, or per-kilometer), door-to-door pickup from anywhere in Pune, real-time GPS tracking, and flexible scheduling. With Meghana Cab’s 24/7 customer support and hassle-free online booking, your Pune to Lavasa Innova Crysta ride promises a smooth, elegant, and memorable escape to the hills.',


        top: 'Top Places to Visit in Lavasa with Meghana Cab',

"topPlaces": [
  {
    "title": "Lakeside Promenade",
    "description": "A scenic waterfront boulevard along Warasgaon Lake, lined with colorful Italian-style buildings, cafés, and alfresco restaurants. Visitors can enjoy pedal boating, cycling, and lakeside strolls while admiring the manicured gardens and hills beyond. Daytime is ideal for active leisure, while evenings come alive with street musicians and family outings."
  },
  {
    "title": "Warasgaon (Temghar) Dam",
    "description": "Located just outside Lavasa, this massive reservoir on the Mutha River offers panoramic views of the dam wall, lake, and surrounding Western Ghats. It’s a popular picnic destination—especially in the monsoon—where visitors can walk along the dam crest, photograph the water-concrete contrast, or relax on grassy slopes."
  },
  {
    "title": "Lakeshore Watersports",
    "description": "A modern facility by the lake offering a range of water adventures—kayaking, pedal boats, bumper rides, jet skis, and even luxury lake cruises. These activities add an active dimension to Lavasa’s tranquil vibe, and are ideal for families and groups seeking fun with water-backed mountain scenery."
  },
  {
    "title": "Bamboosa",
    "description": "A cultural and eco-tourism initiative nestled within the forested hills around Lavasa, showcasing indigenous bamboo craft and rural livelihood. Visitors can watch artists at work, purchase handicrafts, learn about sustainable bamboo architecture, and enjoy short nature walks—an offbeat yet meaningful addition to the hill station experience."
  },
  {
    "title": "Temghar Dam Viewpoint",
    "description": "A small hilltop lookout offering bird’s-eye views of the Temghar reservoir, hills, and Lavasa townscape. Easily accessible by car, it’s ideal for early morning photographers and couples, offering clear vistas of mist-laced valleys and the engineered dam structure below."
  },
  {
    "title": "Tamhini Ghat Drive",
    "description": "The winding road through Tamhini Ghat connects Lavasa to the Mulshi region—famed for its green tunnels, waterfalls, and panoramic viewpoints. The route is a visual delight, especially during monsoon, and connects to spots like Bhira Reservoir, Vyawreshwar Falls, and forested walking trails."
  },
  {
    "title": "Adventure Zone & District Sports Hub",
    "description": "Clustered near the lakeside promenade, this outdoor activity center features go-karting, archery, trampolines, and a small children’s play zone, alongside simple cafés. It’s perfect for families and adventure-seekers looking for varied fun in one accessible location."
  },
  {
    "title": "Hilltop Villas & Viewpoints",
    "description": "Lavasa’s hillside is dotted with colorful villas and observation decks that offer dramatic views of the lake and valley. A short hike or drive up reveals quiet vantage spots perfect for sunset, yoga, or pre-wedding photo shoots amid landscaped greenery."
  },
  {
    "title": "Walking & Cycling Trails",
    "description": "Lavasa offers well-maintained paths through forested patches, along lake shores, and on hill routes. Trail maps are available near the promenade and dam, guiding visitors through beginner-friendly nature walks or longer routes up the hills for birdwatching and solitude."
  },
  {
    "title": "Italian-Themed Café Zone",
    "description": "A cluster of chic cafés designed with pastel facades and Sicilian themes, serving artisan coffee, local Goan and continental fare, and desserts. Ideal for slow meals with a view—particularly at sunset, when the golden light reflects off the lake onto the buildings."
  }
],

"services": [
  {
    "name": "Pune to Lavasa Innova Crysta Cab Booking",
    "description": "Book your Pune to Lavasa Innova Crysta cab for a scenic and comfortable journey to this hill city. Whether it’s a leisure getaway, a day trip, or a weekend escape, our well-maintained Innova Crysta offers ample space, smooth rides, and professional chauffeurs for a worry-free experience."
  },
  {
    "name": "One Way Innova Crysta Pune Lavasa",
    "description": "Enjoy a one-way trip from Pune to Lavasa in a premium Innova Crysta. This service is perfect for travelers seeking direct, non-shared, and comfortable transportation to this serene destination. Doorstep pickup and drop are included."
  },
  {
    "name": "Round Trip Innova Crysta Pune Lavasa",
    "description": "Plan a convenient round trip to Lavasa from Pune in a chauffeur-driven Innova Crysta. Get flexible return options, top-tier comfort, and personalized travel support for sightseeing, picnics, or family retreats."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Lavasa",
    "description": "Travel in a fully air-conditioned Innova Crysta from Pune to Lavasa for a relaxed and refreshing experience. With climate control, comfortable seats, and plenty of legroom, you’ll enjoy the cool ride even on warmer days."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune Lavasa",
    "description": "Let our experienced chauffeurs handle the winding roads from Pune to Lavasa while you enjoy the comfort of a premium Innova Crysta. Our drivers are courteous, punctual, and knowledgeable about the route and stops along the way."
  },
  {
    "name": "Private Innova Crysta Taxi Pune Lavasa",
    "description": "Get full privacy and peace of mind with our private Innova Crysta cab service to Lavasa. Perfect for couples, families, or small groups who want exclusive use of a clean, luxurious vehicle with no ride-sharing."
  },
  {
    "name": "Online Booking Innova Crysta Cab Pune Lavasa",
    "description": "Book your Innova Crysta cab from Pune to Lavasa online in minutes. Our platform is fast, secure, and offers instant confirmations, transparent pricing, and full control over pickup time and travel customization."
  },
  {
    "name": "Family Innova Crysta Trip Pune Lavasa",
    "description": "Make your Lavasa family trip stress-free with a spacious 6- or 7-seater Innova Crysta. Enjoy reclining seats, AC comfort, child-safe features, and enough boot space for picnic bags, strollers, and luggage."
  },
  {
    "name": "Budget Innova Crysta Cab Pune Lavasa",
    "description": "Looking for a budget-friendly way to reach Lavasa from Pune? Our economical Innova Crysta rental options provide premium travel comfort without stretching your wallet—ideal for short trips, sightseeing, or day-long escapes."
  }
],
"tableData": [
  ["Pune to Lavasa Innova Crysta Cab Booking", "One Way Innova Crysta Pune Lavasa"],
  ["Round Trip Innova Crysta Pune Lavasa", "AC Innova Crysta Taxi Pune Lavasa"],
  ["Chauffeur Driven Innova Crysta Pune Lavasa", "Private Innova Crysta Taxi Pune Lavasa"],
  ["Online Booking Innova Crysta Cab Pune Lavasa", "Family Innova Crysta Trip Pune Lavasa"],
  ["Budget Innova Crysta Cab Pune Lavasa", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Lavasa Innova Crysta Cab Booking",
        "WhyChoosedescription": "Travel from Pune to the scenic hill city of Lavasa in a spacious, air-conditioned Innova Crysta. Whether it's a weekend getaway, family trip, or romantic escape, our cab service ensures a smooth, luxurious, and stress-free ride to this popular destination."
    },
    {
        "WhyChooseheading": "Spacious Interiors with Premium Features",
        "WhyChoosedescription": "The Innova Crysta offers generous legroom, reclining seats, rear AC vents, and ample luggage space—ideal for 6–7 passengers. Enjoy the comfort of a luxury vehicle while navigating the hilly roads to Lavasa."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Hill Routes",
        "WhyChoosedescription": "Our drivers are well-versed with the winding ghat roads leading to Lavasa. They ensure safe, smooth, and steady driving through the hills while helping you arrive on time and with ease."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All our Innova Crysta vehicles are regularly serviced and thoroughly cleaned before each trip. We prioritize hygiene and maintenance, giving you a reliable and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Flexible Booking and Custom Itineraries",
        "WhyChoosedescription": "Choose between one-way trips, round-trip bookings, or hourly rentals. Customize pickup/drop locations and request stopovers at scenic viewpoints or cafes along the route to make the most of your Lavasa trip."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Our fares include fuel, driver charges, and tolls, with no last-minute surprises. Enjoy clear, upfront pricing for a premium service that fits your budget."
    },
    {
        "WhyChooseheading": "Ideal for Family Outings, Couples, and Weekend Escapes",
        "WhyChoosedescription": "Whether it’s a peaceful family retreat, a friends’ road trip, or a romantic weekend, the Innova Crysta offers the space and comfort needed for a memorable ride to Lavasa."
    },
    {
        "WhyChooseheading": "24/7 Booking Assistance and Support",
        "WhyChoosedescription": "Book your Pune to Lavasa cab anytime through our website or helpline. Our support team is available 24/7 to help with scheduling, changes, and special requests for a stress-free experience."
    }
]
























    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Lavasa?",
        answer: "You can book easily by calling Meghana Cab at +91 9075462128 or by visiting our website for a seamless booking experience."
    },
    {
        question: "What is the distance and travel time between Pune and Lavasa?",
        answer: "The distance is approximately 60 km, and it takes around 1.5 to 2 hours to reach Lavasa from Pune, depending on traffic."
    },
    {
        question: "Is Innova Crysta suitable for the Pune to Lavasa route?",
        answer: "Yes, Innova Crysta is ideal for the hilly terrain and winding roads to Lavasa, offering comfort and safety."
    },
    {
        question: "Can I book a one-way or round trip to Lavasa?",
        answer: "Yes, we provide both one-way and round-trip booking options based on your itinerary."
    },
    {
        question: "Is the Innova Crysta cab available for family or group travel?",
        answer: "Absolutely. It can accommodate 6 to 7 passengers and is perfect for family outings or group travel."
    },
    {
        question: "Is the cab service available 24/7 from Pune to Lavasa?",
        answer: "Yes, Meghana Cab offers 24/7 cab services to Lavasa, including early morning and late-night travel."
    },
    {
        question: "Are your cabs sanitized before every trip?",
        answer: "Yes, all our vehicles are thoroughly cleaned and sanitized before each journey to ensure safety and hygiene."
    },
    {
        question: "Do your drivers have experience with hill routes like Lavasa?",
        answer: "Yes, our drivers are trained and experienced in handling hill station routes safely and efficiently."
    },
    {
        question: "What is included in the fare for Pune to Lavasa cab service?",
        answer: "The fare includes fuel, tolls, and driver charges. Any parking or waiting time may incur extra charges."
    },
    {
        question: "What payment options are available for booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sandeep Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Innova Crysta from Pune to Lavasa and it was a fantastic ride. The car was clean and very comfortable.”',
    },
    {
        name: 'Ms. Pooja Karandikar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our Lavasa weekend getaway super easy and comfortable. Highly recommend their Innova Crysta service!”',
    },
];














































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToLavasaInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Lavasa Innova Crysta Cab Booking",
  "description": "Book chauffeur-driven Innova Crysta cab from Pune to Lavasa for one way or round trip travel. AC taxi service ideal for family and business trips at affordable rates.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Lavasa"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-lavasa-innova-crysta-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Lavasa Innova Crysta Cab | Chauffeur Driven AC Taxi</title>
  <meta
    name="description"
    content="Hire Innova Crysta cab with chauffeur from Pune to Lavasa. One way and round trip AC taxi booking available for family and corporate travel."
  />
  <meta
    name="keywords"
    content="Pune to Lavasa Innova Crysta Cab Booking, One Way Innova Crysta Pune Lavasa, Round Trip Innova Crysta Pune Lavasa, AC Innova Crysta Taxi Pune Lavasa, Chauffeur Driven Innova Crysta Pune Lavasa, Private Innova Crysta Taxi Pune Lavasa, Online Booking Innova Crysta Cab Pune Lavasa, Family Innova Crysta Trip Pune Lavasa, Budget Innova Crysta Cab Pune Lavasa"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToLavasaInnovaSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolavasainnovacab;